import { VFlow } from 'bold-ui'

import { NewsHeadingSection } from '../components/NewsHeadingSection'
import { NewsListItem } from '../components/NewsListItem'
import { NewsSectionContent } from '../components/NewsSectionContent'

export function NewsInternalEstabilizacaoV55() {
  return (
    <VFlow>
      <NewsHeadingSection title='Versão 5.5.29' id='estabilizacao-5-5-29'>
        <NewsSectionContent>
          <NewsListItem>
            Correção de cenário de chave duplicada durante a etapa de processamento de cidadãos vinculados.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.28' id='estabilizacao-5-5-28'>
        <NewsSectionContent>
          <NewsListItem>
            Ajuste no campo de forma farmacêutica, indicando que o usuário deve buscar para selecionar o valor
            correspondente.
          </NewsListItem>
          <NewsListItem>
            Ajustes e adaptações visuais nos componentes da videochamada para correto funcionamento em dispositivos
            móveis.
          </NewsListItem>
          <NewsListItem>
            Ajustado o fluxo de navegação do anfitrião para que, quando por algum motivo ele sair da videochamada, o
            redirecionamento padrão seja sempre para a sala de espera.
          </NewsListItem>
          <NewsListItem>
            Correção de mau funcionamento do botão "Retornar à página anterior" apresentado nas telas de erro.
          </NewsListItem>
          <NewsListItem>
            Correção na exibição da transcrição da caderneta ao imprimir a retificação do atendimento de procedimento.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que a opção de visualizar o Acompanhamento de Pré-natal e Puerpério, na tela de
            Cuidado compartilhado, apresentava erro de página não encontrada.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que a tentativa de visualizar o gráfico de pressão arterial no Acompanhamento de
            pré-natal redirecionava para a aba incorreta.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.27' id='estabilizacao-5-5-27'>
        <NewsSectionContent>
          <NewsListItem>
            Correção de cenário em que não estava sendo possível cadastrar lote de imunobiológico referente à vacina
            para fabricante SINOVAC (DALIAN).
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que o processamento de relatórios apresentava lentidão na etapa de deleção de
            registros.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.26' id='estabilizacao-5-5-26'>
        <NewsSectionContent>
          <NewsListItem>
            Habilitados os botões de "Cancelar atendimento individual" e "Cancelar escuta inicial" na aba de
            Acompanhamento de pré-natal.
          </NewsListItem>
          <NewsListItem>
            Implementado o fluxo de reconexão automática (com tempo máximo de 1 minuto) durante a videochamada, com
            aviso visual ao usuário e direcionamento para tela de erro caso a conexão não seja restabelecida.
          </NewsListItem>
          <NewsListItem>
            Implementada uma mensagem de aviso que informa ao usuário quando ocorrer instabilidade na conexão durante a
            videochamada ou em suas etapas de acesso.
          </NewsListItem>
          <NewsListItem>
            Inclusão de alerta ao prescrever Insulina NPH indicando as novas recomendações do SUS para alterar o
            tratamento para Insulina Glargina.
          </NewsListItem>
          <NewsListItem>
            Novo item de "PNCT Manutenção" incluído nas Práticas em saúde do registro de Atividade coletiva.
          </NewsListItem>
          <NewsListItem>
            Depreciação do CNS e priorização do CPF, tendo este como dado único do cidadão nas Fichas de avaliação de
            Elegibilidade no CDS.
          </NewsListItem>
          <NewsListItem>
            Correção do cálculo da pontuação das perguntas 14 e 18 referentes à Entrevista de Seguimento.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que não era possível excluir um cidadão da lista de atendimentos após ele ser chamado
            no painel de chamadas.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que ao identificar problemas e condições do histórico de diabetes ou hipertensão com
            código AB, impossibilitava a finalização do atendimento.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde algumas vacinas apresentadas no histórico de atendimentos não eram consideradas na
            lista temática de saúde da mulher no Acompanhamento de condições de saúde.
          </NewsListItem>
          <NewsListItem>Correção na fila de requisições para o CADSUS.</NewsListItem>
          <NewsListItem>
            Correção de cenário em que não estava sendo possível realizar a atualização de algumas bases devido a um
            erro de processamento de vínculo no Acompanhamento de cidadãos vinculados.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.25' id='estabilizacao-5-5-25'>
        <NewsSectionContent>
          <NewsListItem>
            Inclusão do item Fornecimento de kit bucal no campo Práticas em saúde da Atividade coletiva, também
            disponível nos relatórios de produção e em seus filtros personalizados.
          </NewsListItem>
          <NewsListItem>
            Depreciação do CNS e priorização do CPF, tendo este como dado único do cidadão nas Fichas de atividade
            coletiva no CDS.
          </NewsListItem>
          <NewsListItem>
            Passa a ser permitida a inclusão de atendimentos de Escuta inicial na impressão em lote do Histórico clínico
            do cidadão, gerando um único PDF com os registros selecionados.
          </NewsListItem>
          <NewsListItem>
            Atualização da base de endereços do sistema, mantendo os dados de localidades em conformidade com a versão
            de 2026.
          </NewsListItem>
          <NewsListItem>Atualização da tabela de procedimentos SIGTAP para a competência de 06/2026.</NewsListItem>
          <NewsListItem>
            Correção de cenário em que o sistema bloqueava a importação de fichas com procedimentos de código AB em
            problemas/condições.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde atendimentos de Pré-natal, Puericultura e Puerpério realizados no CDS não
            apresentavam a devida classificação no histórico.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.24' id='estabilizacao-5-5-24'>
        <NewsSectionContent>
          <NewsListItem>
            Ajuste de erro em que alguns imóveis não estavam sendo exibidos corretamente no CDS.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde não estava sendo possível realizar a atualização do sistema em algumas instalações.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.23' id='estabilizacao-5-5-23'>
        <NewsSectionContent>
          <NewsListItem>
            Reorganização do acesso aos módulos de Cadastro individual e Acompanhamento do território.
          </NewsListItem>
          <NewsListItem>Criação do novo perfil padrão no e-SUS com o nome Mediador intercultural.</NewsListItem>
          <NewsListItem>
            Inclusão de informações complementares dos fabricantes de vacinas para facilitar sua identificação nos
            registros de vacinação.
          </NewsListItem>
          <NewsListItem>Inclusão do campo CID-10 no módulo de Antecedentes familiares.</NewsListItem>
          <NewsListItem>Reorganização no fluxo de configuração do painel de chamadas.</NewsListItem>
          <NewsListItem>
            Atualização das regras de faixa etária e aprazamento para o registro da aplicação do imunobiológico "Pneumo
            20".
          </NewsListItem>
          <NewsListItem>
            Atualização dos campos e regras de validação para suportar o novo formato de CNPJ alfanumérico, em
            conformidade com a Instrução Normativa 2.229 da Receita Federal.
          </NewsListItem>
          <NewsListItem>
            Priorização do CPF como chave principal do cidadão no Atendimento Domiciliar e no Cadastro Domiciliar e
            Territorial do CDS, tornando o preenchimento do CNS habilitado apenas se o cidadão não possuir CPF.
          </NewsListItem>
          <NewsListItem>
            Correção de erro na Lista de atendimentos em que a equipe responsável não era carregada ao editar um
            atendimento.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
    </VFlow>
  )
}
